let publicUrl = document.head.querySelector('meta[name="public_url"]').getAttribute('content')
let meses = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"]
let short_meses = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"]
let dias = ["Domingo", "Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"]
let short_dias = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"]

module.exports = {
    checkImage: (image_url, isStorage = false) => {
        if (!/^(f|ht)tps?:\/\//i.test(image_url)) {
            if (isStorage == true) { return publicUrl + 'storage/' + image_url }
            else { return publicUrl + image_url }
        } else {
            return image_url
        }
    },

    dateToString: (fecha) => {
        if(fecha == null) { return }
        var f = new Date(fecha.replace(/-/g,"/")); //Fix UTC "-" to Local "/"
        return dias[f.getDay()] + ", " + f.getDate() + " de " + meses[f.getMonth()] + " de " + f.getFullYear()
    },

    dateToStringShort: (fecha) => {
        if(fecha == null) { return }
        var f = new Date(fecha.replace(/-/g,"/")); //Fix UTC "-" to Local "/"
        return f.getDate() + " de " + meses[f.getMonth()] + " de " + f.getFullYear()
    },

    capitalizeFirstLetter: (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1)
    },

    inputError: (errors, field, classname) => {
        if(errors) { if(errors[field]) { return classname; } } return ''
    },

    textTruncate: (str, length, ending) => {
        if (length == null) { length = 100 }  
        if (ending == null) { ending = '...' }  
        if (str.length > length) {  
            return str.substring(0, length - ending.length) + ending; 
        } else { return str }  
    },

    getShortDias: () => { return short_dias },
    getDias: () => { return dias },
    getShortMeses: () => { return short_meses },
    getMeses: () => { return meses },

    getStringTodayDate: () => {
        var today = new Date()
        var dd = today.getDate()
        var mm = today.getMonth() + 1
        var yyyy = today.getFullYear()
        if(dd < 10) { dd ='0'+ dd } 
        if(mm < 10) { mm = '0' + mm } 
        return yyyy + '-' + mm + '-' + dd
    },

    formatBytes: (bytes, decimals) => {
        if (bytes == 0) { return '0 Bytes' }
        var k = 1000,
            dm = decimals + 1 || 3,
            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },

    formatCurrency: (value) => {
        var val = parseFloat(value)
        return '$' + val.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
    },

    slugify: (value) => {
        value = value.replace(/^\s+|\s+$/g, '')
        value = value.toLowerCase()
        var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;"
        var to   = "aaaaaeeeeeiiiiooooouuuunc------"
        for (var i = 0, l = from.length; i < l; i++) {
            value = value.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
        }
        value = value.replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-')
        return value
    },

    shareSocialMedia: (media, url, title = '') => {
        switch (media) {
            case 'facebook':
                return 'https://www.facebook.com/sharer/sharer.php?u=' + url
            case 'twitter':
                return 'https://twitter.com/intent/tweet?text=' + url
            case 'linkedin':
                return 'https://www.linkedin.com/shareArticle?mini=true&url=' + url + '&title=' + title + '&summary=&source='
            case 'whatsapp':
                return 'whatsapp://send?text=' + url
            case 'email':
                return 'mailto:?subject=' + title + '&body='  + url
            default: 
                return url
        }
    }
}